module.exports = __webpack_public_path__ + "static/media/logo.331c0e1d.png";